import React from "react";
import haulage_img from "../../Images/haulage.jpg";
import { useEffect } from "react";
const Haulage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-0 m-0 box-border">
      <div className="w-[90%] mx-auto my-12 font-Poppins">
        <h2 className="text-2xl lg:text-3xl font-semibold py-6">
          Haulage And Removal Expertise
        </h2>

        <div className="flex flex-col-reverse lg:flex-row justify-between items-center gap-6 lg:gap-2">
          <div className="w-full lg:w-[48%]">
            <p className="text-lg pb-6">
              <p className="text-xl lg:font-3xl font-semibold pb-6">
                Leading Industry Knowledge & Experience
              </p>
              We are a premier Haulage and Removal company offering
              comprehensive freight transportation solutions from start to
              finish. Each member of our team plays an integral role in running
              an efficient and responsive operation. We optimize our service
              performance by maintaining our high standards and experienced
              support. Our team is passionate about providing world class
              Haulage and Removal management services to our valued customers.
            </p>
            <p className="text-lg pt-2 pb-8">
              Our services are positioned towards growth and refinement as we
              continuously push the boundaries in determining the best possible
              strategies, innovations, and technology needed to make our client
              experience even better. Our combined knowledge and experience
              gives our management team insight into each customer’s
              transportation challenges and how we can cater to their needs by
              bringing convenience and value.
            </p>
          </div>
          <div className="w-full lg:w-[48%]">
            <img src={haulage_img} alt="" className="w-full rounded-md" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Haulage;
